import styled from '@emotion/styled';
import Select from 'components/Kizen/Select';

export const Wrapper = styled.div`
  position: relative;
  display: inline-flex;
  margin-left: 20px;

  button {
    flex: 1;
    margin: 0;
    height: 28px;
    padding: 0;

    i + i {
      padding: 0 0 0 8px;
    }
  }
`;

export const ButtonMenu = styled(Select)`
  > :first-child {
    width: 152px;
    position: absolute;
    bottom: 0;
    right: 0;
  }
  .ButtonMenu__control {
    display: none;
  }
  .ButtonMenu__menu {
    position: absolute;
    top: 0;
    right: 0;
    width: auto;
    max-width: 100%;
    border: 1px solid var(--color-border-medium);
    border-radius: 4px;
  }
`;
